import { post , get , put} from '@/utils/request'
// 交易管理售后详情
export const queryDelivery = (data) => {
    return post(`/supplier/transport/query`,data)
}
